import React from 'react';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import H6 from '@base/H6/H6';
import P2 from '@base/P2/P2';
import Paper from '@base/Paper/Paper';
import Notes from '@icon/Syllabus/Notes';

interface INotesCardProps {
  marginBottom?: string;
}

const Wrapper = styled(Paper)`
  height: 70px;
  display: flex;
  align-items: center;
  flex-grow: 1;
  padding: 0 ${Spacings.SPACING_6B};
  margin-bottom: ${({
    // @ts-ignore
    $marginBottom
  }) => $marginBottom};
`;

const InfoWrapper = styled.div`
  margin-left: ${Spacings.SPACING_4B};
`;

const StyP2 = styled(P2)`
  margin-top: ${Spacings.SPACING_1B};
`;

const StyH6 = styled(H6)`
  line-height: 18px;
`;

const NotesCard: React.FC<INotesCardProps> = ({ marginBottom }) => {
  return (
    <Wrapper
      // @ts-ignore
      $marginBottom={marginBottom}
      data-testid="notes-card-wrapper"
    >
      <Notes size={Spacings.SPACING_8B} />
      <InfoWrapper>
        <StyH6>Notes</StyH6>
        <StyP2 color="var(--color-text-secondary)">
          Available on android app
        </StyP2>
      </InfoWrapper>
    </Wrapper>
  );
};

export default NotesCard;

NotesCard.defaultProps = {
  marginBottom: '0px'
};
